module.exports = __webpack_public_path__ + "fonts/HalisR-S-Bold.8ce829f1.otf";